//import my-pik form "./components/Animation/pik-my.png"
//I Would Highly Recommend You To Customize The Theme According To Your Taste.
//import imgpic from "./components/Animation/pik-my.png"
export const globalStyles = {
  "--grad": "linear-gradient(315deg,#48a9fe,#00cdac)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #48a9fe 0%, #734ae8 74%)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #06bcfb 0%, #4884ee 74%)",
  "--txtcolor": "#272341",
  "--p_color": "#00cdac",
  "--s_color": "#fff",
};

// Navigation Bar Name
export const navbar_name = "<Rajarsi>";

// Main Page
export const main = {
  name: "Rajarsi Mukherjee",
  doamin: "A MERN Stack Web Developer",
  resume:
    "https://drive.google.com/file/d/1-Zzot0FPr9ciEkV--lBB8NTRB2-f_i5U/view?usp=sharing",
};

// AboutMe
export const aboutme = {
  
 imgLink: "https://raw.githubusercontent.com/RajarsiMukherjee/youtube-clone/main/my%20pik%20new-cropped.png",
  p1: "Hey, My name is Rajarsi Mukherjee. I have completed my Bachelor of Engineering from Techno India University, Kolkata(W.B.).",
  p2: " I'm a passionate coder and an enthusiastic Web Developer capable of applying programming skills to solve complex problems. Seeking a challenging role in the field of software development that will offer an opportunity for further development of my abilities, skills and knowledge in an organization.",
  p3: "Apart from coding I also like yoga, cooking , read news and explore new political history and national things.",
};
//https://github.com/ashish1234sharma/pictures/blob/main/resume%20pic-modified%20(1).png?raw=true
// Skills 
export const whatido = {
  title: "Full Stack Development",

  details: [
    "Building responsive website using HTML,CSS,JS,React",
    "Creating backend application in Node, ExpressJS",
    "Building Simple RESTful CRUD APIs",
    "Knowledge of MongoDB Database",
    "Knowledge of various UI libraries",
  ],
  logos: [
    {
      name: "HTML5",
      iconifyClassName: "vscode-icons:file-type-html", // PS : Use iconify class name
      id: "1",
    },
    {
      name: "CSS",
      iconifyClassName: "vscode-icons:file-type-css",
      id: "2",
    },
    {
      name: "JavaScript",
      iconifyClassName: "logos:javascript",
      id: "3",
    },
    {
      name: "ReactJS",
      iconifyClassName: "vscode-icons:file-type-reactjs",
      id: "4",
    },
    {
      name: "Redux",
      iconifyClassName: "logos:redux",
      id: "5",
    },
    {
      name: "NodeJS",
      iconifyClassName: "logos:nodejs",
      id: "6",
    },
    {
      name: "ExpressJS",
      iconifyClassName: "logos:express",
      id: "7",
    },
    {
      name: "MongoDB",
      iconifyClassName: "logos:mongodb",
      id: "8",
    },
    {
      name: "Postman",
      iconifyClassName: "logos:postman-icon",
      id: "9",
    },
    {
      name: "npm",
      iconifyClassName: "logos:npm-icon",
      id: "10",
    },
    {
      name: "GIT",
      iconifyClassName: "logos:git",
      id: "11",
    },
    {
      name: "Tailwind",
      iconifyClassName: "logos:tailwindcss-icon",
      id: "12",
    },
    {
      name: "Material-UI",
      iconifyClassName: "logos:material-ui",
      id: "13",
    },
    {
      name: "Ant Design",
      iconifyClassName: "logos:ant-design",
      id: "14",
    },
    {
      name: "Netlify",
      iconifyClassName: "vscode-icons:file-type-netlify",
      id: "15",
    },
    {
      name: "Vercel",
      iconifyClassName: "logos:vercel-icon",
      id: "16",
    },
  ],
};

// Project Details
export const details = [
  {
    id: 1,
    title: "Paula's Choice Clone",
    desc: `In this project we have tried to make a look alike clone of Paula's Choice. With our efforts and the technology stack, that we have learned till now in Unit-4 in Masai School, we were able to clone the front end, integrated it with backend and added similar looks and features.`,
    feature: `Sign-in/Sign-up,
              backend database is use to show product and add to cart, explore various products,
              Payment pages.`,
    tech: `Tech Stack: EJS | CSS | JavaScript | nodeJS | express | MongoDB `,
    img: "https://raw.githubusercontent.com/RajarsiMukherjee/youtube-clone/main/palur's.png",
    link: "https://modest-visvesvaraya-03d3c2.netlify.app/",
    github: "https://github.com/sac1010/paula_s_choice-backend",
    
  },
  {
    id: 2,
    title: "Sugar Cosmetics Clone",
    desc: `This is a clone of SugerCosmetic. that's provide E-buying facility and makeup items.`,
    feature: `Sign-in/Sign-up,
              corousel image,
              Dynamic product page,
              payment gateway,Dynamic cart page with coupon functionality.`,
    tech: `Tech Stack: HTML | CSS | JavaScript`,
    img: "https://raw.githubusercontent.com/RajarsiMukherjee/youtube-clone/main/sugarCos.png",
    github: "https://github.com/RajarsiMukherjee/SugerCosmeties",
    link: "https://competent-bardeen-b9ae59.netlify.app/index.html"
  },
  
  {
    id: 6,
    title: "Twitter Clone ",
    desc: `Twitter is a microblogging platform where people can express their thoughts in short posts which people can read and share! We built a Twitter Clone using React JS in the frontend along with Firebase as a Backend provider. We used Firebase Firestore as a database and used Firebase Hosting to bring our clone to live on the internet. We can post along with Images. We will also be fetching real Twitter posts for a section in our Clone application. Our team consists of Five members from FT-WEB14, this is 4th construct week for us. As we construct/clone a web page, this is our project from the 5th unit at Masai School.`,
    feature: `Landing page,login & Register page,Home page,Profile page,Tweet option,Search users.`,
    tech: `Tech Stack: ReactJS | Firebase | HTML | CSS | Material UI`,
    img: "https://raw.githubusercontent.com/RajarsiMukherjee/youtube-clone/main/Image/Screenshot%20(13).png",
    link: "https://twitter-clone-ba49b.web.app/",
    github: "https://github.com/RajarsiMukherjee/Twitter_Clone",
  },

  {
    id: 7,
    title: "My E-commerce",
    desc: `This is a E-Commerce website designed by me. that's provide E-buying facility of clothes items.`,
    feature: `Landing page, Dynamic product page, payment gateway,Dynamic cart page functionality.`,
    tech: `Tech Stack: React JS | Redux | CSS | Material UI | MongoDB |NodeJS`,
    img: "https://raw.githubusercontent.com/RajarsiMukherjee/E-commerce-using-React-Redux/main/Screenshot%20(31).png",
    link: "https://mac-e-commerce-rajarsimukherjee.vercel.app/",
    github: "https://github.com/RajarsiMukherjee/E-commerce-using-React-Redux",
  }

  
];

// Social Media Links
export const links = [
  
  "https://www.linkedin.com/in/rajarsi-mukherjee-11035119b",
  "https://api.whatsapp.com/send/?phone=919064223289&text&app_absent=0",
  //"mailto:rajarsimukerjee@gmail.com",
  "https://github.com/RajarsiMukherjee",
];
